import { imageNames } from "@/src/constants/imageConstants.js";
import { featureNames } from "@/src/constants/globalConstants";

export const fundingStages = [
  "Angel",
  "Seed",
  "Series A",
  "Series B",
  "Series C",
  "Series D",
  "Series E",
  "Series F",
  "Debt Financing",
  "Public",
];

export const revenueOptions = [
  { value: 0, label: "$0" },
  { value: 1000, label: "$1K" },
  { value: 10000, label: "$10K" },
  { value: 100000, label: "$100K" },
  { value: 500000, label: "$500K" },
  { value: 1000000, label: "$1M" },
  { value: 5000000, label: "$5M" },
  { value: 10000000, label: "$10M" },
  { value: 25000000, label: "$25M" },
  { value: 50000000, label: "$50M" },
  { value: 100000000, label: "$100M" },
  { value: 500000000, label: "$500M" },
  { value: 1000000000, label: "$1B" },
  { value: 5000000000, label: "$5B" },
  { value: 10000000000, label: "$10B" },
];

export const yearsOfExperienceOptions = Array.from({ length: 50 }, (_, i) => ({
  value: i + 1,
  label: `${i + 1} year${i + 1 === 1 ? "" : "s"}`,
}));

export const employeeRanges = [
  "1-10",
  "11-50",
  "51-100",
  "101-250",
  "251-500",
  "501-1000",
  "1001-5000",
  "5001-10000",
  "10001-50000",
  "50001+",
];

export const locationRadiusOptions = [25, 50, 100, 300];

export const personalityOptions = [
  { value: "awestruck", label: "😲 Awestruck" },
  { value: "bold", label: "💪 Bold" },
  { value: "compassionate", label: "😊 Compassionate" },
  { value: "convincing", label: "🙂 Convincing" },
  { value: "enthusiastic", label: "😃 Enthusiastic" },
  { value: "formal", label: "👔 Formal" },
  { value: "friendly", label: "😊 Friendly" },
  { value: "joyful", label: "🎉 Joyful" },
  { value: "professional", label: "💼 Professional" },
  { value: "relaxed", label: "⛱️ Relaxed" },
];

export const languageOptions = [
  { value: "en-US", label: "🇺🇸 American English" },
  { value: "en-GB", label: "🇬🇧 British English" },
  { value: "es", label: "🇪🇸 Spanish" },
  { value: "nl", label: "🇳🇱 Dutch" },
  { value: "fr", label: "🇫🇷 French" },
  { value: "de", label: "🇩🇪 German" },
  { value: "it", label: "🇮🇹 Italian" },
  { value: "he", label: "🇮🇱 Hebrew" },
  { value: "pt-PT", label: "🇵🇹 Portuguese" },
  { value: "pt-BR", label: "🇧🇷 Brazilian Portuguese" },
];

export const campaignTypes = {
  AUTOMATED: "AUTOMATED",
  MANUAL: "MANUAL",
  AUTOMATION: "AUTOMATION",
  MANUAL_LIST: "MANUAL_LIST",
  MANUAL_SEQUENCE: "MANUAL_SEQUENCE",
};

export const completeCampaignTabs = {
  OVERVIEW: "overview",
  REPLIES: "replies",
  ANALYTICS: "analytics",
  OUTPUT: "output",
};

export const campaignTabs = {
  CAMPAIGN: "campaign",
  REPLIES: "replies",
};

export const overviewStages = [
  { key: "ICP", name: "ICP" },
  { key: "OFFER", name: "Value Prop" },
  { key: "SENDER", name: "Sender Details" },
  { key: "STEPS", name: "Outreach Messaging" },
  { key: "SETTINGS", name: "Automation" },
];

export const baseCampaignStages = {
  FILTER: "FILTER",
  ESTABLISH_ICP: "ESTABLISH_ICP",
  ADD_LEADS: "ADD_LEADS",
  ADD_OFFER: "ADD_OFFER",
  MAILBOX_SETTINGS: "MAILBOX_SETTINGS",
  ADD_STEPS: "ADD_STEPS",
  ADD_SETTINGS: "ADD_SETTINGS",
};
export const dateRanges = [
  { label: "All Time", value: null },
  { label: "6 Months", value: "6m" },
  { label: "1 Year", value: "12m" },
  { label: "3 Years", value: "36m" },
  { label: "5 Years", value: "60m" },
];
export const campaignStatusMap = {
  DRAFT: "DRAFT",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETE: "COMPLETE",
  CANCELLED: "CANCELLED",
  ENDED: "ENDED",
  NOT_SENT: "NOT_SENT",
};

export const campaignStepTypes = {
  EMAIL: "EMAIL",
  LINKEDIN_INMAIL: "LINKEDIN_INMAIL",
  LINKEDIN_INVITE: "LINKEDIN_INVITE",
  LINKEDIN_MESSAGE: "LINKEDIN_MESSAGE",
  LINKEDIN_POST_REACTION: "LINKEDIN_POST_REACTION",
};

export const campaignTypeOptions = [
  {
    id: campaignTypes.AUTOMATED,
    title: "Find new leads",
    description: "Let SuperAGI source and enrich leads",
    icon: imageNames.AGI_MARK,
    alt: "agi_mark_icon",
  },
  {
    id: campaignTypes.MANUAL,
    title: "Upload a lead list",
    description: "Provide a CSV of leads and SuperAGI will do the outreach",
    icon: imageNames.UPLOAD_GREY,
    alt: "upload_icon",
  },
  {
    id: campaignTypes.MANUAL_LIST,
    title: "Select a list",
    description: "Select an existing list in SuperAGI",
    icon: imageNames.ADD_LIST_GREY,
    alt: "list_icon",
  },
];

export const sequenceTypeOptions = [
  {
    id: campaignTypes.MANUAL_SEQUENCE,
    title: `Manual ${featureNames.SEQUENCES}`,
    description: `Add contacts 1:1 to the ${featureNames.SEQUENCES}`,
    icon: imageNames.UPLOAD_GREY,
    alt: "upload_icon",
  },
];

export const campaignHeaders = [
  { label: "Name", key: "name", width: 3 },
  { label: "Status", key: "status", width: 2 },
  { label: "Total Leads", key: "leads_contacted", width: 1 },
  { label: "Total Sent", key: "total_sent", width: 1 },
  { label: "Total Clicks", key: "total_clicked", width: 1 },
  { label: "Replies", key: "total_replies", width: 1 },
  { label: "Created on", key: "created_at", width: 3 },
];

export const overviewSenderDetailsHeaders = [
  { label: "Email", key: "email", width: 4, prefix: "vendor_icon" },
  { label: "Signature Source", key: "template_type", width: 3 }, // Use Name/Use Signature
  { label: "Signature", key: "signature", width: 5, html: true },
];

export const signatureSource = {
  SENDER_NAME: "Sender Name",
  SENDER_SIGNATURE: "Sender Signature",
};

export const repliesCategoryOptions = [
  "INTERESTED",
  "NOT_INTERESTED",
  "OUT_OF_OFFICE",
  "MEETING_REQUEST",
  "INFORMATION_REQUEST",
  "WRONG_PERSON",
  "DO_NOT_CONTACT",
];

export const foundingYears = Array.from(
  { length: new Date().getFullYear() - 1901 + 1 },
  (_, i) => 1901 + i,
).reverse();
//
// export const foundingYears = [
//   "1901", "1902", "1903", "1904", "1905", "1906", "1907", "1908", "1909", "1910",
//   "1911", "1912", "1913", "1914", "1915", "1916", "1917", "1918", "1919", "1920",
//   "1921", "1922", "1923", "1924", "1925", "1926", "1927", "1928", "1929", "1930",
//   "1931", "1932", "1933", "1934", "1935", "1936", "1937", "1938", "1939", "1940",
//   "1941", "1942", "1943", "1944", "1945", "1946", "1947", "1948", "1949", "1950",
//   "1951", "1952", "1953", "1954", "1955", "1956", "1957", "1958", "1959", "1960",
//   "1961", "1962", "1963", "1964", "1965", "1966", "1967", "1968", "1969", "1970",
//   "1971", "1972", "1973", "1974", "1975", "1976", "1977", "1978", "1979", "1980",
//   "1981", "1982", "1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990",
//   "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000",
//   "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010",
//   "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020",
//   "2021", "2022", "2023", "2024"
// ];

export const postReactions = [
  { label: "Celebrate", emoji: "👏🏻" },
  { label: "Funny", emoji: "😂" },
  { label: "Insightful", emoji: "💡" },
  { label: "Like", emoji: "👍🏻" },
  { label: "Love", emoji: "❤️" },
  { label: "Support", emoji: "🤝🏻" },
];

export const postDays = [
  { label: "3 days", value: 3 },
  { label: "7 days", value: 7 },
  { label: "30 days", value: 30 },
];

export const LISTING_STATE_STORAGE_KEY = "cold-outreach-listing-state";
